var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSonometro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.744,
    height: 88.745,
    viewBox: "0 0 88.744 88.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1041",
    "data-name": "Grupo 1041",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_1",
    "data-name": "Sustracci\\xF3n 1",
    d: "M44.372,88.745A44.385,44.385,0,0,1,27.1,3.487,44.384,44.384,0,0,1,61.644,85.258,44.1,44.1,0,0,1,44.372,88.745ZM32.615,34.677c-.045,0-.09,0-.135,0a3.237,3.237,0,0,0-2.807,2.553,2.025,2.025,0,0,0,.552,1.773L38.392,48a6.094,6.094,0,1,0,5.779-4.14h-.028a6.289,6.289,0,0,0-1.978.345l-7.983-8.789A2.019,2.019,0,0,0,32.615,34.677Zm11.67-8.625h0A23.008,23.008,0,0,1,67.147,46.758a2.3,2.3,0,0,0,2.3,2.3c.072.006.156.011.242.011a2.306,2.306,0,0,0,2.288-2.313,27.605,27.605,0,0,0-55.21,0,2.3,2.3,0,1,0,4.6,0A22.988,22.988,0,0,1,41.96,26.168C42.732,26.091,43.515,26.052,44.286,26.052Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSonometro);
export default __webpack_public_path__ + "static/media/ic_sonometro.f64ac1108d912f40b1d909829e0482b2.svg";
export { ForwardRef as ReactComponent };